@use '@/styles/tokens' as *;

.stepper {
  display: flex;
  align-items: stretch;

  // Remove right-side radius + border from InputNumber so it flows into the buttons.
  :global(.ant-input-number) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.input {
  flex: 1;
  width: 100%;
}

// Stepper +/- buttons sit flush against the right edge of the input.
.stepBtn {
  border-left: none !important;
  border-radius: 0 !important;
  // Match the InputNumber's neutral-400 border colour exactly.
  border-color: $color-neutral-200 !important;

  &:hover {
    // Keep the same border — don't turn green like a regular outline button.
    border-color: $color-neutral-300 !important;
    background-color: $color-white-100 !important;
  }

  &:last-child {
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
  }
}

// When the field is in an error state, propagate the red border to the buttons.
.stepBtnError {
  border-color: $color-error-900 !important;

  &:hover {
    border-color: $color-error-900 !important;
  }
}
